import { Injectable, Inject } from '@angular/core';
import { Observable ,  ReplaySubject } from 'rxjs';
import { StaleDatedCheckFilters } from './stale-dated-check-filters.model';
import { FiltersService } from '../../dashboard/filters/filters.service';
import { StaleDatedCheckDurationType } from '../stale-dated-check-view.model';
import { filter } from 'rxjs/operators';
import { Util } from '../../../../util';
import { DashboardFilters } from '../../dashboard/filters/dashboard-filters.model';

@Injectable()
export class StaleCheckFiltersService {
  private subject: ReplaySubject<StaleDatedCheckFilters>;
  private _lastFilters: StaleDatedCheckFilters;

  private _suppressUpdate = false;

  constructor(@Inject(FiltersService) private _dashboardFiltersService: FiltersService) {
    this.subject = new ReplaySubject<StaleDatedCheckFilters>(1);
    this._dashboardFiltersService.getFilters()
      .pipe(
      filter((filt) => filt.payDate !== Util.MIN_DATE || !this._lastFilters)
    )
      .subscribe(filters => {
      if (!this._suppressUpdate) {
        if (this._lastFilters) {
          this.updateFilters(this._lastFilters.copy(filters));
        } else {
          this.updateFilters(this.createDefaultFilter(filters));
        }
      }
    });
  }

  updateFilters(filters: StaleDatedCheckFilters) {
    this._lastFilters = filters;
    this.subject.next(filters);
  }

  clearFilters() {
    if (this._lastFilters) {
      this._lastFilters.reset();
    }
  }

  getFilters(): Observable<StaleDatedCheckFilters> {
    return this.subject.asObservable();
  }

  createDefaultFilter(innerFilters: DashboardFilters): StaleDatedCheckFilters {
    return new StaleDatedCheckFilters(
      innerFilters,
      StaleDatedCheckDurationType.CurrentUpcomingStaleDatedChecks,
    );
  }
}
